import { createElement } from 'react';
import { ksdpChecklistReadPermission } from '@internal/ksdp-permissions-common';
import { guardKsdpPage } from '@internal/ksdp-permissions-react';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { ChecklistApprovalPage } from './ChecklistApprovalPage';
import { ChecklistApprovalIcon } from './icons/ApprovalIcon';

const checklistApprovalPage = PageBlueprint.make({
  name: 'checklist-approval',
  params: {
    path: '/checklist-approval',
    title: 'Compliance Audit Checklist Approval',
    icon: createElement(ChecklistApprovalIcon),
    loader: async () =>
      guardKsdpPage(
        ksdpChecklistReadPermission,
        createElement(ChecklistApprovalPage),
      ),
  },
});

export const checklistApprovalPlugin = createFrontendPlugin({
  pluginId: 'checklist-approval',
  extensions: [checklistApprovalPage],
});
